import React from "react";
import { BlockTypes } from "../helpers/enums";
import { SelectableBlock } from "./SelectableBlock";
import { AdminTextBlock } from "../TextBlock/AdminTextBlock";
import { AdminImageBlock } from "../ImageBlock/AdminImageBlock";
import { EditVideoBlock } from "../VideoBlock/EditVideoBlock";
import { EditVideoScrollBlock } from "../VideoScrollBlock/EditVideoScrollBlock";
import { EditQuizBlock } from "../QuizBlock/EditQuizBlock";
import { EditThreeDBlock } from "../ThreeDBlock/EditThreeDBlock";
import { EditCodewordBlock } from "../codeword/EditCodewordBlock";
import { ReadMoreBlock } from "../read-more/ReadMoreBlock";
import { BlockProvider } from "../read-more/blockContext";
import { ReadMoreContent } from "../read-more/ReadMoreContent";
import { ReadMoreSettings } from "../read-more/ReadMoreSettings";
import { CopyBlockButton } from "./CopyBlockButton";
import { RemoveBlockButton } from "./RemoveBlockButton";

export const renderAdminBlock = ({
  sectionId, containerId, blockId, block, blockState,
  isActiveBlock, backgroundColor, isAdminMode,
  handleCommitState, handleUpdateState, handleUpdate,
  handleCopyBlock, handleRemoveBlock,
}) => {
  const actions = (
    <>
      <CopyBlockButton
        sectionId={sectionId}
        containerId={containerId}
        block={block}
        onCopy={handleCopyBlock}
      />
      <RemoveBlockButton blockId={blockId} onRemove={handleRemoveBlock} />
    </>
  );

  const wrap = (children, onBlur) => (
    <SelectableBlock sectionId={sectionId} containerId={containerId} blockId={blockId} onBlur={onBlur}>
      {children}
    </SelectableBlock>
  );

  switch (block.type) {
    case BlockTypes.TEXT:
      return wrap(
        <AdminTextBlock
          block={blockState.data}
          text={block.text}
          placeholder={blockState.data.placeholder}
          isActiveBlock={isActiveBlock}
          onPropertyUpdate={handleUpdateState}
          onBlockUpdate={handleUpdate}
        >
          {actions}
        </AdminTextBlock>,
        handleCommitState
      );

    case BlockTypes.IMAGE:
      return wrap(
        <AdminImageBlock
          sectionId={sectionId}
          containerId={containerId}
          block={block}
          onUpdate={handleUpdate}
          isActiveBlock={isActiveBlock}
        >
          {actions}
        </AdminImageBlock>
      );

    case BlockTypes.VIDEO:
      return wrap(
        <EditVideoBlock block={block} onUpdate={handleUpdate} isActiveBlock={isActiveBlock}>
          {actions}
        </EditVideoBlock>
      );

    case BlockTypes.VIDEO_SCROLL:
      return wrap(
        <EditVideoScrollBlock
          block={block}
          onUpdate={handleUpdate}
          isActiveBlock={isActiveBlock}
          sectionId={sectionId}
        >
          {actions}
        </EditVideoScrollBlock>
      );

    case BlockTypes.QUIZ:
      return wrap(
        <EditQuizBlock
          block={blockState.data}
          isActiveBlock={isActiveBlock}
          onPropertyUpdate={handleUpdateState}
          containerBackground={backgroundColor}
        >
          {actions}
        </EditQuizBlock>,
        handleCommitState
      );

    case BlockTypes.THREE_D:
      return wrap(
        <EditThreeDBlock
          sectionId={sectionId}
          containerId={containerId}
          blockId={blockId}
          block={block}
          onUpdate={handleUpdate}
          isActiveBlock={isActiveBlock}
        >
          {actions}
        </EditThreeDBlock>
      );

    case BlockTypes.READ_MORE:
      return (
        <BlockProvider>
          {wrap(
            <ReadMoreBlock blockState={blockState.data} isActiveBlock={isActiveBlock} isAdminMode={true}>
              <RemoveBlockButton blockId={blockId} onRemove={handleRemoveBlock} />
              <CopyBlockButton sectionId={sectionId} containerId={containerId} block={block} onCopy={handleCopyBlock} />
            </ReadMoreBlock>
          )}
          <ReadMoreContent blockState={blockState.data} isAdminMode={isAdminMode} onUpdate={handleUpdate} />
          <ReadMoreSettings
            onUpdateProperty={handleUpdateState}
            onUpdate={handleCommitState}
            blockState={blockState.data}
          />
        </BlockProvider>
      );

    case BlockTypes.CODEWORD:
      return wrap(
        <EditCodewordBlock
          sectionId={sectionId}
          containerId={containerId}
          blockId={blockId}
          block={block}
          onRemove={handleRemoveBlock}
        >
          <RemoveBlockButton blockId={blockId} onRemove={handleRemoveBlock} />
        </EditCodewordBlock>
      );

    default:
      return null;
  }
};
